import { CmmFileType } from '../../../shared/types/cmmConfig.ts';


export function doesExtensionMatch(
    fileName: string,
    cmmFileType: CmmFileType,
): boolean {
    const extension = fileName.split('.').pop()?.toLowerCase();
    if (!extension) return false;

    switch (cmmFileType) {
        case 'csv':
            return extension === 'csv';
        case 'excel':
            return ['xlsx', 'xlsm', 'xls'].includes(extension);
        default:
            return false;
    }
}
